/**
 * 用作計算user選擇了什麼資源
 * @type {Store<{subcate_resource_list: Array, subcate_total_select: number, subcate_total_size: number, my_download_resource_list: Array, my_download_total_select: number, my_download_total_size: number}>}
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const resource_store = {
    namespaced: true,
    state: {
        full_list: [],
        cate_title: [],
        cate_list: [],
        table_heading: "",
        total_resources: -1,
        content_type: "single",
        filter:null,
        subcate_resource_list: [], //在subcate 頁面選擇了什麼resource
        subcate_total_select: 0,
        subcate_total_size: 0,
        my_download_resource_list: [], //my download的resource記錄
        my_download_total_select: 0,
        my_download_total_size: 0,
        num_of_new_resource: 0, //記錄是次增加了多少個資源到my download
        check_all_resource: false, //simple content check all status
        check_all_group_resource: [], //group content check all status [0 => false, 1 => false]
        download_display_type: "single", //single | double
        show_check_box: true,
        activeFilters: []
    },
    mutations: {
        add (state, obj) {
            state.subcate_resource_list[obj.row] = obj.metadata_id;
            state.subcate_total_select++;
            state.subcate_total_size = state.subcate_total_size + obj.size;
        },
        remove(state, obj) {
            delete state.subcate_resource_list[obj.row];
            state.subcate_total_select--;
            state.subcate_total_size = state.subcate_total_size - obj.size;
        },
        clear_sub_cate(state) {
            state.subcate_resource_list = [];
            state.subcate_total_select = 0;
            state.subcate_total_size = 0;
            if (state.check_all_group_resource.length > 0) {
                state.check_all_group_resource.forEach(function(value, key) {
                    state.check_all_group_resource[key] = false;
                });
            }
        },
        update_new_resource(state, count) {
            state.num_of_new_resource = count;
        },
        update_check_all_status(state, status) {
            state.check_all_resource = status;
        },
        setCateData(state, payload) {
            for (let key in payload) {
                state[key] = payload[key];
            }
        },
        setFilteredItems(state,payload) {

            state.total_resources = 0;

            if (payload.length) {
                for (let [index, item] of state.cate_list.entries()) {
                    Vue.set(state.cate_list[index], 'is_filtered', payload[index]);

                    if (!payload[index]) {
                        state.total_resources++;
                    }
                }
            } else {
                for (let [index, item] of state.cate_list.entries()) {
                    Vue.set(state.cate_list[index], 'is_filtered', null);
                }

                state.total_resources = payload.length;
            }
        },
        setFilteredItemsGroup(state,payload) {

            state.total_resources = 0;

            if (payload.length) {
                for (let [groupIndex, groupItem] of state.cate_list.entries()) {
                    if (groupItem.resource) {
                        for (let [resIndex, resItem] of groupItem.resource.entries()) {
                            Vue.set(state.cate_list[groupIndex]["resource"][resIndex], 'is_filtered', payload[groupIndex][resIndex]);

                            if (!payload[groupIndex][resIndex]) {
                                state.total_resources++;
                            }
                        }
                    }
                }
            } else {
                for (let [groupIndex, groupItem] of state.cate_list.entries()) {
                    if (groupItem.resource) {
                        for (let [resIndex, resItem] of groupItem.resource.entries()) {
                            Vue.set(state.cate_list[groupIndex]["resource"][resIndex], 'is_filtered', null);
                            state.total_resources++;
                        }
                    }

                }
            }
        },
        alterActiveFilters(state, payload) {
            /*let index = state.activeFilters.findIndex(el => el === payload)
            if(index === -1) {
                state.activeFilters.push(payload)
            }
            else {
                state.activeFilters.splice(index, 1)
            }*/
            state.activeFilters = payload
        }
    },
    getters: {
        total: state => {
            return state.resource;
        },
        total_select_overall: state => {
            return state.subcate_total_select + state.my_download_total_select;
        },
        total_size_overall: state => {
            return state.subcate_total_size + state.my_download_total_size;
        },
        select_num_of_new_resource: state => {
            return state.subcate_total_select;
        },
        check_all_status: state => {
            return state.check_all_resource;
        },
        download_display_type: state => {
            return state.download_display_type;
        },
        /*activeFilters: state => {
            return state.activeFilters
        }*/
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/resource.js